export default "__VITE_ASSET__1afc5948__"